import { AbstractControl, ValidationErrors } from '@angular/forms';

const httpsScheme = 'https://';
const schemeRegex = new RegExp(/^([a-z][a-z0-9+\-.]*):/);

export function urlValidator(control: AbstractControl): ValidationErrors | null {
    if (typeof control.value !== 'string') {
        return invalidUrl();
    }

    let value: string = control.value;
    if (!schemeRegex.test(control.value)) {
        // assume https scheme
        value = httpsScheme + value;
    }

    try {
        new URL(value);
        return null;
    } catch {
        return invalidUrl();
    }
}

function invalidUrl(): object {
    return { invalidUrl: true };
}
